
export const OPERATING_HOURS = {
  weekdays: '10:00 AM - 7:00 PM',
  saturdays: '9:00 AM - 1:00 PM',
  sundays: 'Closed',
  display: {
    weekdays: 'Weekdays: 10:00 AM - 7:00 PM',
    saturdays: 'Saturdays: 9:00 AM - 1:00 PM',
    sundays: 'Sundays: Closed'
  },
  assessment: {
    monday: 'Monday: 9:00 AM - 7:00 PM',
    tuesday: 'Tuesday: 5:00 PM - 7:00 PM',
    wednesday: 'Wednesday: 9:00 AM - 7:00 PM',
    thursday: 'Thursday: 5:00 PM - 7:00 PM',
    friday: 'Friday: 5:00 PM - 7:00 PM',
    saturday: 'Saturday: 9:00 AM - 7:00 PM',
    sunday: 'Sunday: 9:00 AM - 7:00 PM'
  }
};
